import { gql, useMutation, useQuery } from '@apollo/client';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { BreadCrumb, BreadCrumbProp } from '../../../../components/light/Breadcrumb';
import { Content } from '../../../../components/light/Content';
import { SectionBlock } from '../../../../components/light/SectionBlock';
import { Loading } from '../../../../components/Loading';
import { ContextUser } from '../../../../context/ContextUser';

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: 'Applications',
    to: '#'
  },
  {
    text: 'Products',
    to: '#'
  },
  {
    text: 'Sponsor Product',
    to: '/sponsor/list'
  }
];

const QUERY = gql`
query merchantSponsorList{
  merchantSponsorList{
    id
    name
    amount
    rate
    totalImpression
    totalRemaining
    createdAt
    finishedAt
    status
  }
}`;

const MUTATION = gql`
  mutation merchantSponsorCancel($campaign_id: Int!) {
    merchantSponsorCancel(campaign_id: $campaign_id)
  }
`;

export function SponsorListScreen(){
  const context = useContext(ContextUser);
  const [filter, setFliter] = useState<"APPROVED" | "PENDING" | "REJECTED" | "ACTIVE" | string>('PENDING');
  const {data,loading} = useQuery(QUERY, {
    fetchPolicy: 'no-cache'
  });
  const [merchantSponsorCancel] = useMutation(MUTATION, {
    refetchQueries: ["merchantSponsorList"],
  });

  if(data === undefined || loading) {
    return(
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-6">
            <SectionBlock title="Sponsor Product" transparent={true}>
              <Loading />
            </SectionBlock>
          </div>
        </div>
      </Content>
    )
  }

  return(
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems}/>}>
      <div className="row">
        <div className="col-md-10">
          <SectionBlock title="Sponsor Product" transparent={true}>
            <label className="text-success">Current Balance {context.merchant.balance} USD</label>
            <br/>
            <br/>
            <div className="row">
              <div className="col-md-6">
                <div className="dataTables_length">
                  <label>
                    Filter
                      <select
                      className="form-control form-control-sm"
                      style={{ width: 100 }}
                      value={filter}
                      onChange={(e) =>
                        setFliter(e.target.value)
                      }
                    >
                      <option value="APPROVED">APPROVED</option>
                      <option value="PENDING">PENDING</option>
                      <option value="REJECTED">REJECTED</option>
                      <option value="ACTIVE">ACTIVE</option>
                    </select>
                  </label>
                </div>
              </div>
              <div className="col-md-6 text-right">
                <div className="dataTables_length">
                  <Link to="/sponsor/create" className="btn btn-secondary btn-sm">Create new sponsor</Link>
                </div>
              </div>
            </div>
            <table className="table table-padded">
              <thead>
                <tr>
                  <th>Sponsor Name</th>
                  <th>Amount</th>
                  <th className="text-center">Impression</th>
                  <th className="text-center">Remaining</th>
                  <th className='text-right'>Start Date</th>
                  <th className='text-right'>Finish Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {
                  data.merchantSponsorList.filter((x: any) => x.status === filter).map((x: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td>{x.name}</td>
                        <td>
                          <span className="text-success">{x.amount} USD</span>
                          <br/>
                          <small className="text-muted">{x.rate}</small>
                        </td>
                        <td className="text-center">{x.totalImpression}</td>
                        <td className="text-center">{x.totalRemaining}</td>
                        <td className='text-right'>{x.createdAt}</td>
                        <td className='text-right'>{x.finishedAt}</td>
                        <td className="text-center">
                          {
                            x.status === 'PENDING' && (
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                  merchantSponsorCancel({
                                    variables: { campaign_id: Number(x.id) },
                                  })
                                }
                              >Cancel</button>
                            )
                          }
                          <Link 
                            to={`/sponsor/detail/${x.id}?from=${moment(x.createdAt).format('YYYY-MM-DD')}&to=${x.finishedAt === null ? moment(new Date()).format('YYYY-MM-DD') : moment(x.finishedAt ).format('YYYY-MM-DD')}`} 
                            className="btn btn-primary btn-sm"
                          >Detail</Link>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </SectionBlock>
        </div>
      </div>
    </Content>
  )
}